var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.item),function(val,key){return _c('v-col',{key:key,attrs:{"cols":"6","md":"4"}},[_c('v-card',{staticClass:"justify-center align-center"},[_c('v-card-text',{staticClass:"overline"},[_vm._v(" "+_vm._s(_vm.$lang(key))+" ")]),_c('v-divider'),_c('v-card-text',[_vm._v(" "+_vm._s(val)+" ")])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }